import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// ANT DESIGN IMPORTS
import { ArrowDownOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Card, Input, Pagination, Row, Select, Spin, Table, Tag } from "antd";

// PROJECT IMPORTS
import ArrowRight from "@untitled-ui/icons-react/build/esm/ArrowRight";
import SearchLg from "@untitled-ui/icons-react/build/esm/SearchLg";
import "../../../assets/styles/Bond.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";

import { apiConfig, labelConfig, staticConfig } from "../product.config";

import DownloadTableButtons from "../../../components/layouts/enhancement/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";

const columns = [
  {
    dataIndex: "templateName",
    sorter: (a, b) => a.templateName.localeCompare(b.templateName),
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        Certificate Name
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    sortDirections: ["ascend"],
  },
  {
    title: "Certificate Code",
    dataIndex: "templateCode",
  },
  {
    title: "Certificate Type",
    dataIndex: "templateTypeText",
  },
  // {
  //   title: "Effective From",
  //   dataIndex: "effectiveFrom",
  // },
  // {
  //   title: "Effective To",
  //   dataIndex: "effectiveTo",
  // },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text) => {
      let bgColor = "#F9FAFB"; // default bg
      let textColor = "#344054"; // default text
      let border = "1px solid #EAECF0";

      switch (text) {
        case "Active":
          bgColor = "#ECFDF3";
          textColor = "#067647";
          border = "1px solid #ABEFC6";
          break;
        case "Disabled":
          bgColor = "#FCEBEB";
          textColor = "#750606";
          border = "1px solid #F0ADAD";
          break;
        case "Closed":
          bgColor = "#FCEBEB";
          textColor = "#750606";
          border = "1px solid #F0ADAD";
          break;
        case "Inactive":
          bgColor = "#FEE4E2";
          textColor = "#B42318";
          break;
        case "Matured":
          bgColor = "#EFF8FF";
          textColor = "#175CD3";
          border = "1px solid #B2DDFF";
          break;
        case "Rejected":
          bgColor = "#FEF3F2";
          textColor = "#B42318";
          border = "1px solid #FECDCA";
          break;
        case "Approved":
          bgColor = "#EEF4FF";
          textColor = "#3538CD";
          border = "1px solid #C7D7FE";
          break;
        case "WithdrawnByApplicant":
          bgColor = "#F0F9FF";
          textColor = "#026AA2";
          border = "1px solid #B9E6FE";
          break;
        case "SubmittedAndPendingApproval":
          bgColor = "#F4F3FF";
          textColor = "#5925DC";
          border = "1px solid #D9D6FE";
          break;
        default:
          break;
      }

      return (
        <Tag
          style={{
            padding: "2px 12px",
            borderRadius: "16px",
            border: border,
            fontSize: "12px",
            fontWeight: 500,
            display: "inline-block",
            backgroundColor: bgColor,
            color: textColor,
            textTransform: "capitalize",
          }}
        >
          {text}
        </Tag>
      );
    },
  },
];

const ManageCertificate = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  // const { monthList } = appStatic;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState("10");
  const [originalList, setOriginalList] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("Status");
  const pageSize = 10;

  useEffect(() => {
    BOM.HasPermission("READ_CERTIFICATE_TEMPLATE") && getCertificateTemplatesList();
    BOM.HasPermission("CREATE_CERTIFICATE_TEMPLATE") && rightAction(cnt.RIGHT_ADD_BTN);
    // BOM.HasPermission("CREATE_CERTIFICATE_TEMPLATE") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  const filteredData = useMemo(() => {
    let data = [...originalList];

    // filter by status
    if (selectedStatus && selectedStatus !== "Status") {
      data = data.filter((item) => item?.status?.toLowerCase() === selectedStatus?.toLowerCase());
    }

    // filter by search
    if (searchKey) {
      data = data.filter((item) =>
        [item.productName, item.currency, item.issuerName, item.productType].some((field) =>
          field?.toLowerCase().includes(searchKey.toLowerCase()),
        ),
      );
    }

    return data;
  }, [selectedStatus, searchKey, originalList]);

  const totalPages = Math.ceil(filteredData.length / pageSize);

  // Handle select change
  function handleFilterByStatus(newStatus) {
    setSelectedStatus(newStatus);
  }

  function handleSearchInTable(e) {
    setSearchKey(e.target.value);
  }

  const getCertificateTemplatesList = () => {
    // START LOAD
    setIsLoading(true);

    let body = { session, method: "GET" };
    const url = `${apiConfig.certificateTemplates}`;
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          console.log(res);
          const objList = res;
          let tempArray = [];
          let tempId = "";

          console.log(res);
          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              productName: element?.productName || "-",
              productType: element?.productType || "-",
              templateName: element?.templateName || "-",
              templateCode: element?.templateCode || "-",
              templateType: element?.templateType || "-",
              templateTypeText: element?.templateTypeText || "-",
              templateStatus: element?.templateStatus || "-",
              templateStatusText: element?.templateStatusText || "-",
              // effectiveFrom: element?.effectiveFrom || "-",
              // effectiveTo: element?.effectiveTo || "-",
              status: element?.templateStatusText,
            });
            // tempId = element.savingsProductData.id;
          });

          // console.log(tempId);

          setOriginalList(tempArray);
          //STOP LOAD
          setIsLoading(false);
          setTableCount(tempArray.length);
        }
      },
      "treasury",
    );
  };

  //DECLARED METHODS
  const onSelectItemAction = (record, selected, selectedRows) => {
    if (!selected || selectedRows.length !== 1) {
      setSelectedRow(null);
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });

      BOM.HasPermission("CREATE_BOND") && dispatch({ type: cnt.RIGHT_ADD_BTN });
      return;
    }

    setSelectedRow(record); // ✅ record is the full object

    [
      BOM.HasPermission("READ_LOANPRODUCT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_LOANPRODUCT") && cnt.RIGHT_EDIT_BTN,
    ].forEach((item) => {
      item &&
        dispatch({
          type: item,
        });
    });
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn?.toLowerCase() === "primary") {
      navigate("/view-certificate-template", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-certificate-template", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn?.toLowerCase() === "primary") {
      console.log(selectedRow);
      navigate("/edit-certificate-template", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      pageItems={staticConfig.certificateTemplateItems}
    >
      <TopContent
        pageTitle={labelConfig.certificateTemplate}
        createPageTitle={labelConfig.certificateTemplatesList}
      />

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search"
                prefix={<SearchLg width={18} color="#667085" />}
                style={{
                  width: 320,
                  borderRadius: "10px",
                }}
              />
            </div>
            <div
              style={{
                margin: "0px 10px",
                display: "flex",
                alignItems: "center",
                // backgroundColor: "#F9FAFB",
                // borderRadius: 50,
                border: "none",
                // borderColor: "#EAECF0",
                padding: 2,
                width: "fit-content",
              }}
            >
              <Select
                defaultValue="Status"
                options={staticConfig.statusLabels}
                onSelect={handleFilterByStatus}
                bordered={false}
                style={{
                  backgroundColor: "#F9FAFB",
                  border: "1px solid #EAECF0",
                  // backgroundColor: "transparent",
                  borderRadius: 50,
                  height: 30,

                  // minWidth: 120,
                }}
                dropdownStyle={{
                  borderRadius: 8,
                  width: "250px",
                }}
              />
            </div>

            <DownloadTableButtons
              downloadData={filteredData}
              columns={columns}
              fileName={"Bonds List"}
            />
          </Row>
          <Table
            className="bond-table"
            rowSelection={{
              onSelect: onSelectItemAction,
              hideSelectAll: true,
            }}
            columns={columns}
            dataSource={originalList}
            pagination={false}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            {/* Empty space on the left */}
            <div>
              <Button
                style={{
                  backgroundColor: "white",
                  borderRadius: 8,
                  border: "1px solid #D0D5DD",
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                className="previous-button"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                <ArrowLeftOutlined style={{ width: "20px", height: "20px" }} /> Previous
              </Button>
            </div>

            {/* Centered Pagination */}
            <div style={{ flex: 1, textAlign: "center" }}>
              <Pagination
                current={currentPage}
                total={filteredData.length} // ✅ instead of tableCount
                pageSize={pageSize}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
                itemRender={itemRender}
                align="center"
              />
            </div>

            {/* Next button on the right */}
            <div>
              <Button
                style={{
                  backgroundColor: "white",
                  borderRadius: 8,
                  border: "1px solid #D0D5DD",
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                className="previous-button"
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage >= totalPages}
              >
                Next <ArrowRight style={{ width: "20px", height: "20px" }} />
              </Button>
            </div>
          </div>
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageCertificate);
